import CityData from '../assets/CityCountyData.json';
/**
 * 由 CityCountyData.json 建索引
 * - cityToZips: { TPE: ["100","103",...], ... }
 * - zipToCity:  { "100": "TPE", ... }
 * - zipToAreaZh: { "100": "中正區", ... }
 * - cityCodeToNameZh: { TPE: "臺北市", ... }
 * - cityList: [{ code: "TPE", name: "臺北市" }, ...]（供下拉）
 */
function buildIndex(rows) {
  const cityToZips = {};
  const zipToCity = {};
  const zipToAreaZh = {};
  const zipToAreaEn = {};
  const cityCodeToNameZh = {};
  const cityCodeToNameEn = {};
  const cityList = [];

  rows.forEach((c) => {
    cityCodeToNameZh[c.CityCode] = c.CityName;
    cityCodeToNameEn[c.CityCode] = c.CityEngName;
    cityList.push({ code: c.CityCode, zh: c.CityName, en: c.CityEngName });

    const zips = [];
    c.AreaList.forEach((a) => {
      zips.push(a.ZipCode);
      zipToCity[a.ZipCode] = c.CityCode;
      zipToAreaZh[a.ZipCode] = a.AreaName;
      zipToAreaEn[a.ZipCode] = a.AreaEngName;
    });
    cityToZips[c.CityCode] = zips;
  });

  const labels = {
    city: (code, lang = 'zh') =>
      (lang.startsWith('en') ? cityCodeToNameEn[code] : cityCodeToNameZh[code]) || '',
    area: (zip, lang = 'zh') =>
      (lang.startsWith('en') ? zipToAreaEn[zip] : zipToAreaZh[zip]) || '',
  };

  const helpers = {
    isValidCityCode: (code) => Object.hasOwn(cityToZips, code),
    isZipInCity: (code, zip) => (cityToZips[code] || []).includes(zip),
    getZipsByCity: (code) => cityToZips[code] || [],
    getCityByZip: (zip) => zipToCity[zip] || null,
    // ☆ 補回你正在用的函式（支援 zh/en）
    getAreaNameByZip: (zip, lang = 'zh') => labels.area(zip, lang),
  };

  return {
    cityToZips, zipToCity, zipToAreaZh, zipToAreaEn,
    cityCodeToNameZh, cityCodeToNameEn, cityList, helpers, labels
  };
}

export const City_INDEX = buildIndex(CityData);